import { ToastDialogContext } from '@rhg/providers/toast-dialog';
import { useContext } from 'react';

export default function useToastDialog() {
    return useContext(ToastDialogContext);
}
